import React from 'react';
import { useIntl } from 'react-intl';
import messages from './FieldMessages';
import RenderProperty from './RenderProperty';
import { formatListValue } from '../../../../shared/components/FormattedListValue';

const AuthorizationChange = props => {
  const intl = useIntl();
  const { log } = props;

  if (log.oldValue === null) {
    return (
      <span>
        {intl.formatMessage(messages.AddedAuthorization, {
          property: RenderProperty({ intl, log }),
          name: formatListValue({ id: log.newValue, list: 'authorizationname', intl }),
          b: value => <b>{value}</b>,
        })}
      </span>
    );
  }

  return (
    <span>
      {intl.formatMessage(messages.DeletedAuthorization, {
        property: RenderProperty({ intl, log }),
        name: formatListValue({ id: log.oldValue, list: 'authorizationname', intl }),
        b: value => <b>{value}</b>,
      })}
    </span>
  );
};

export default AuthorizationChange;
